<app-dialog [show]="show" [showHeader]="false">
  <app-pharmacy-form [pharmacyId]="pharmacyId"
                     (cancel)="closeEditPharmacyDialog.emit()"
                     (save)="saveEditPharmacyDialog.emit($event)"
  ></app-pharmacy-form>
</app-dialog>
